
import React, { useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { useParams } from 'react-router'
import * as Yup from 'yup'
import { APIURL } from '../../../hoc/AxiosSetting/axios'
import axios from 'axios'

function Stage2ReviewofAudit() {
    const history = useHistory();
    const [initialValues, setInitialValues] = useState(
        {
            id: "",
            orgCode: 0,
            dateofaudit: "",
            teamleaderName: "",
            refno: "",
            conaudittracts: "Yes",
            remarkconaudittracts: "",
            auditnotification: "Yes",
            remarkauditnotification: "",

            leadauditorquali: "Yes",
            remarkleadauditorquali: "",

            actiontakenonissues: "Yes",
            remarkactiontakenonissues: "",

            auditplansent: "Yes",
            remarkauditplansent: "",

            openingandclosing: "Yes",
            remarkopeningandclosing: "",

            auditreportcoverd: "Yes",
            remarkauditreportcoverd: "",

            accomplished: "Yes",
            remarkaccomplished: "",

            investigation: "Yes",
            remarkinvestigation: "",

            responseTocorrectiveaction: "Yes",
            remarkresponseTocorrectiveaction: "",

            noOfsurveillance: "Yes",
            remarknoOfsurveillance: "",

            organizationsite: "Yes",
            remarkorganizationsite: "",

            keyProcess: "Yes",
            remarkkeyProcess: "",

            auditSummary:"Yes",
            remarkauditSummary:"",
                  
            auditimparted:"",
            remarkofstage:"Yes",

            recomendationOfAudit:"Yes",
            remarkrecomendationOfAudit : "",
            nonConfrmities : "Yes",
            remarknonConfrmities : ""
           
        })

    const yesNo = [
        { key: 'Select', value: '-' },
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' },
        { key: 'NA', value: 'NA' },
    ]

    const reviewAcceptance = [
        { key: 'Accepted', value: 'Accepted' },
        { key: 'Rejected', value: 'Rejected' }
    ]

    const auditdropdown = [
        { key: 'Select', value: '-' },
        { key: 'INITIAL CERTIFICATION (STAGE II)', value: ' INITIAL CERTIFICATION (STAGE II)' },
        { key: 'RECERTIFICATION', value: 'RECERTIFICATION' },
        { key: 'SURVEILLANCE', value: 'SURVEILLANCE' },
        { key: 'EXTENSION - SCOPE', value: 'EXTENSION - SCOPE)'},
        { key: 'EXTENSION - SITE', value: 'EXTENSION - SITE)'},
        { key: 'Other', value: 'Other'},

    ]


    const onSubmit = (values, { setSubmitting, resetForm }) => {
        mutation.mutate(values)
    }
    const { orgcode } = useParams()
    // const { data: Rfqdata, isLoading} = useQuery(
    //     'listrfq',
    //     () => Fetcher('get', '/api/stagetwo/get/stagetwodata/'+orgcode, {}))

    // useEffect(() => {
    //     if(Rfqdata && initialValues.orgCode === 0)
    //     {   
    //         var tempData                        = Rfqdata.data.response
    //         tempData.dateofaudit                = Date.parse(tempData.dateofaudit);
    //         setInitialValues(tempData)

    //     }
    // },[orgcode && !isLoading && initialValues.orgCode === 0 ])


    const getUrl = () =>{
        const api= APIURL + '/api/stagetwo/get/stagetwodata/' + orgcode
        axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
        .then(stage2data=>{
            if (stage2data && initialValues.orgCode === 0) {
                var tempData                        = stage2data.data.response
                tempData.dateofaudit                = Date.parse(tempData.dateofaudit);
                setInitialValues(tempData)
                

        }

            
           
        })
        .catch(err=>{
            var string= JSON.stringify(err).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);
            
            console.log("found",found);
            if(found !== null){
                console.log(err)
                window.location.href = "/signin"
            }

        })
    }
   
    useEffect(() => {
        if(orgcode!== undefined){
            getUrl()
        }
       
    }, [orgcode!== undefined])

    const mutation = useMutation((params) => Fetcher('patch', '/api/stagetwo/patch/stagetworeviewauditprocess', params), {

        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Stage Two review process data added')
               window.location.href="/"+localStorage.getItem("role")+'/view/stage2reviewofaudit/'+ data.data.response.orgCode;

            } else {
                var msg = 'Review Process - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })

    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + params, {}), {
        onSuccess(data) {
        
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                tempInitialValues.conaudittracts=data.data.response.conaudittracts || "";
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.refno =data.data.response.refno || "";
                tempInitialValues.remarkofstage =data.data.response.remarkofstage || "";
     
                tempInitialValues.teamleaderName = data.data.response.teamleaderName || "";

                tempInitialValues.auditorOneName = data.data.response.auditorOneName || "";
                tempInitialValues.auditorTwoName = data.data.response.auditorTwoName || "";

                tempInitialValues.conaudittracts = data.data.response.conaudittracts || "Yes"
                tempInitialValues.auditnotification = data.data.response.auditnotification || "Yes"
                tempInitialValues.leadauditorquali = data.data.response.leadauditorquali || "Yes"
                tempInitialValues.actiontakenonissues = data.data.response.actiontakenonissues || "Yes"
                tempInitialValues.auditplansent = data.data.response.auditplansent || "Yes"
                tempInitialValues.openingandclosing = data.data.response.openingandclosing || "Yes"
                tempInitialValues.auditreportcoverd = data.data.response.auditreportcoverd || "Yes"
                tempInitialValues.accomplished = data.data.response.accomplished || "Yes"
                tempInitialValues.investigation = data.data.response.investigation || "Yes"
                tempInitialValues.responseTocorrectiveaction = data.data.response.responseTocorrectiveaction || "Yes"
                tempInitialValues.noOfsurveillance = data.data.response.noOfsurveillance || "Yes"
                tempInitialValues.organizationsite = data.data.response.organizationsite || "Yes"
                tempInitialValues.keyProcess = data.data.response.keyProcess || "Yes"
                tempInitialValues.recomendationOfAudit = data.data.response.recomendationOfAudit || "Yes"
                tempInitialValues.nonConfrmities = data.data.response.nonConfrmities || "Yes" 
                tempInitialValues.auditSummary = data.data.response.auditSummary || "Yes" 
                

                setInitialValues(tempInitialValues)
            } 
            else
            {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })


    const { data: OrgList, isLoading: companyListLoading } = useQuery(
        'listAuditPlan',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesauditplandata/'+localStorage.getItem("userCode"), {}))

        const validationSchema = Yup.object({
           
            auditimparted                : Yup.string().required('Required'),
            remarkofstage                : Yup.string().required('Required'),
            
})

    if (companyListLoading) return <h1>Loading</h1>
    if (orgcode && initialValues.orgCode === 0){
       
        // window.location.href = "/signin"
          return <h1>Loading Data</h1>
         
       }
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={onSubmit}
               validationSchema={validationSchema}
            >
                {formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body">
                                            <div className="row ">
                                                <div className="col-sm-12">
                                                <div className="formOuterDiv">
                                                        <div className="form1RowDiv">
                                                                <FormikControl control='selectNACECode' name='orgCode'label="Name of Audited Organization" options={OrgList.data.response} onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} type="text"  />
                                                        </div>

                                                        <div className="form2RowDiv mt-3" >   
                                                                <FormikControl control='date' dateFormat="dd-MM-yyyy" type="text" name='dateofaudit' label="Date(s) of Audit Conducted"/>
                                                                <FormikControl control='input' type="text" name='teamleaderName' label="Lead Auditor" disabled={true} />
                                                           
                                                        </div>
                                                        <div className="form2RowDiv mt-3" >   
                                                                <FormikControl control='input' type="text" name='auditorOneName' label="Auditor One"  disabled={true} />
                                                                <FormikControl control='input' type="text" name='auditorTwoName' label="Auditor Two" disabled={true} />
                                                           
                                                        </div>

                                                        <div className="form2RowDiv">
                                                                <FormikControl control='select' label="Type of Audit Imparted *" name='auditimparted' options={auditdropdown} />
                                                                <FormikControl control='input' type="text" name='refno' label="Ref No."/>
                                                                
                                                        </div>

                                                        
                                                            <div className="row mt-4">
                                                         
                                                            <label htmlFor="staticEmail" className="col-sm-7 radiolabel">Review Acceptance: for no Conflict of interest with the above organization.</label>
                                                            <div className="col-sm-4">
                                                                <FormikControl control='radio' name='remarkofstage' options={reviewAcceptance} />
                                                        
                                                            </div>
                                                        </div>  
                                                       
                                                        
                                                            <div className="formRowDiv mt-4">
                                                                <div className="col-lg-11 ">
                                                                    <div class="card mb-4">
                                                                        <div class="card-body table-responsive">
                                                                            <table className="table">
                                                                                <thead className="table-primary">
                                                                                    <tr>
                                                                                        <th>#</th>
                                                                                        <th scope="col" className="text-center" width="50%">Review Aspect</th>
                                                                                        <th scope="col" className="text-center">YES/ NO/NA</th>
                                                                                        <th scope="col" className="text-center">REMARK/ DETAILS (IF ANY)</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td className="text-center" >1</td>
                                                                                        <td className="fontcontractviewtable">Contracts have been signed prior to Audit<br/>
                                                                                                         (Applicable to Re-certification/ Transfer Audit….)
                                                                                        </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='conaudittracts' style={{textAlign:"center"}}/></td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkconaudittracts' /> </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="text-center">2</td>
                                                                                        <td className="fontcontractviewtable">Audit Notification and assignment of auditor sign prior to audit</td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='auditnotification' type="text" style={{textAlign:"center"}}/></td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkauditnotification' /> </td>
                                                                                    </tr>
                                                                                    
                                                                                    <tr>
                                                                                        <td className="text-center">3</td>
                                                                                        <td className="fontcontractviewtable">Auditor/ Industrial declaration for no conflict of interest has been signed
                                                                                        </td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='leadauditorquali' style={{textAlign:"center"}}/></td>

                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkleadauditorquali' /> </td>

                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="text-center">4</td>
                                                                                        <td className="fontcontractviewtable">The Lead Auditor (and Technical Expert) is qualified.</td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='actiontakenonissues' style={{textAlign:"center"}}/></td>

                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkactiontakenonissues' /> </td>

                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="text-center">5</td>
                                                                                        <td className="fontcontractviewtable">Action taken on the issue/ NC raise if any during IQCPL last periodical audit (like stage 1, surveillance) are verified by LA and Accepted?
                                                                                        </td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='auditplansent' style={{textAlign:"center"}}/></td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkauditplansent' /> </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="text-center">6</td>
                                                                                        <td className="fontcontractviewtable">The Audit Plan was sent to the client on time and audit conducted as per plan.( Mention actual mandays)

                                                                                        </td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='openingandclosing' style={{textAlign:"center"}}/></td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkopeningandclosing' /> </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="text-center">7</td>
                                                                                        <td className="fontcontractviewtable">Opening and closing meeting done as per scheduled time & prompter covered.
                                                                                        </td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='auditreportcoverd' style={{textAlign:"center"}}/></td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkauditreportcoverd' /> </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="text-center">8</td>
                                                                                        <td className="fontcontractviewtable">The Audit Report covered all the formats as per audit binder
                                                                                        </td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='accomplished' style={{textAlign:"center"}}/></td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkaccomplished' /> </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="text-center">9</td>
                                                                                        <td className="fontcontractviewtable">Was Audit Plan or (Audit Objective for follow-up audits) was accomplished? (All Audits)
                                                                                        </td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='investigation' style={{textAlign:"center"}}/></td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkinvestigation' /> </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="text-center">10</td>
                                                                                        <td className="fontcontractviewtable">Investigation for Corrective/ Preventive Actions is to be satisfactory in case if any “NC”.
                                                                                        </td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='responseTocorrectiveaction' style={{textAlign:"center"}}/></td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkresponseTocorrectiveaction' /> </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="text-center">11</td>
                                                                                        <td className="fontcontractviewtable">Responses to corrective action requests were received and were approved by Lead Auditor (In case of Follow-up Audit).
                                                                                        </td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='noOfsurveillance' style={{textAlign:"center"}}/></td>

                                                                                        <td><FormikControl control='inputtable' type="text" name='remarknoOfsurveillance' /> </td>

                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="text-center">12</td>
                                                                                        <td className="fontcontractviewtable">No. of Surveillance required are decided by Lead Auditor.
                                                                                        </td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='auditSummary' style={{textAlign:"center"}} /></td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkauditSummary' /> </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="text-center">13</td>
                                                                                        <td className="fontcontractviewtable">Audit Summary and Recommendation of audit result clearly addressed.
                                                                                        </td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='recomendationOfAudit' style={{textAlign:"center"}}/></td>

                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkrecomendationOfAudit' /> </td>
                                                                                    </tr>

                                                                                    <tr>
                                                                                        <td className="text-center">14</td>
                                                                                        <td className="fontcontractviewtable">Key processed identified & with production/service provision process audit and audit trail for selected sample covered adequately with recommendation
                                                                                        </td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='keyProcess' style={{textAlign:"center"}}/></td>

                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkkeyProcess' /> </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="text-center">15</td>
                                                                                        <td className="fontcontractviewtable">Non- conformities are corrected by the client and closed-out by Lead Auditor (All
               Audits).   

                                                                                        </td>
                                                                                        <td> <FormikControl control='selecttable' options={yesNo} name='nonConfrmities' style={{textAlign:"center"}}/></td>

                                                                                        <td><FormikControl control='inputtable' type="text" name='remarknonConfrmities' /> </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                   
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-sm-10"></div>
                            <div className="col-sm-2">
                                <button type="submit" className="btn btn-primary float-right">Submit</button>
                            </div>

                        </div>
                    </div>
                    {/* <div className="row">
                        <div className="col-lg-11"></div>
                        <div className="col-lg-1" style={{ marginBottom: "10PX" }}>
                            <button type="submit" className="btn btn-primary">Submit</button>
                        </div>
                    </div> */}

                </Form>

                }
            </Formik>
        </div>
    )
}


export default Stage2ReviewofAudit


